import { render, staticRenderFns } from "./SourceInput.vue?vue&type=template&id=701fa5b2&scoped=true"
import script from "./SourceInput.vue?vue&type=script&lang=js"
export * from "./SourceInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701fa5b2",
  null
  
)

export default component.exports